import type { IEntityModel } from './base'
import type { IProject } from './project'
import type { ITask } from './task'
import type { IWorkspace } from './workspace'

export enum StopwatchGarminStreamAccSampleRate {
  HZ_25 = 25,
  HZ_50 = 50,
  HZ_100 = 100,
}

export interface IStopwatchGarminStream extends IEntityModel {
  taskId: string
  projectId: string
  workspaceId: string
  task?: ITask
  project?: IProject
  workspace?: IWorkspace
  name: string
  description: string
  timeLimitSeconds: number
  accEnable?: boolean
  accHz?: StopwatchGarminStreamAccSampleRate
  ascentEnable?: boolean
  bbiEnable?: boolean
  bodyBatteryEnable?: boolean
  caloriesEnable?: boolean
  heartRateEnable?: boolean
  intensityEnable?: boolean
  pulseOxEnable?: boolean
  respirationEnable?: boolean
  stepEnable?: boolean
  stressEnable?: boolean
  realtimeUpload?: boolean // realtime upload non-acc data to server
}
